import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button, Form, Input } from "antd";

type FormProps = {
  onOk: (values: any) => void;
  onCancel: () => void;
};

export type MessageData = {
  company: string;
  email: string;
  message: string;
  phone: string;
  position: string;
  name: string;
};

const MessageForm: FC<FormProps> = ({ onOk, onCancel }: FormProps) => {
  const { t } = useTranslation();

  const onFinish = (values: MessageData) => onOk(values);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      name="messageForm"
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 24 }}
      style={{ maxWidth: 600 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label={t("name")}
        name="name"
        rules={[{ required: true, message: "Please input your username!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("email")}
        name="email"
        rules={[{ required: true, message: "Please input your email!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("phone")}
        name="phone"
        rules={[{ message: "Please input your phone number!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("position")}
        name="position"
        rules={[{ message: "Please input your position!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("company")}
        name="company"
        rules={[{ message: "Please input your company!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t("message")}
        name="message"
        rules={[{ required: true, message: "Please input your message!" }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item style={{ display: "flex", justifyContent: "end" }}>
        <Button
          type="default"
          onClick={onCancel}
          style={{ marginRight: 8 }}
          htmlType="reset"
        >
          {t("cancel")}
        </Button>
        <Button type="primary" htmlType="submit">
          {t("submit")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default observer(MessageForm);
